export interface BdChartJsImageConverterOptions {
    width: number;
    height: number;
    datalabels: BdChartJsImageConverterDatalabelsOptions

    /**
     * @deprecated - use `datalabels.display`
     */
    hideDatalabels?: boolean;
}

export interface BdChartJsImageConverterDatalabelsOptions {
    display: boolean;
    format: {
        locale: string,
        options: Intl.NumberFormatOptions
    }
}

export const BD_CHART_JS_IMAGE_CONVERTER_OPTIONS_DEFAULT: BdChartJsImageConverterOptions = {
    width: 500,
    height: 500,
    datalabels: {
        display: true,
        format: {
            locale: 'de-DE',
            options: {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        }
    }
};
